import {Layout, Text} from '~/components'
import _ from 'lodash'

export const SeriesPointPopout = ({
	valuesBySeries,
	seriesPointIndex,
	apexObject,
	formatTitle,
	formatSeriesLabel,
	formatSeriesValue,
	extraContent,
}) => {
	if (!apexObject) return null

	const {series, xaxis} = apexObject.config
	const xValue = series.find(({data}) => data[seriesPointIndex])?.data[seriesPointIndex].x
	const formatX = xaxis.labels.formatter
	const lastVisibleSeriesIndex = _.findLastIndex(valuesBySeries, (_, index) => !apexObject.globals.collapsedSeriesIndices.includes(index))

	let popoutTitle = xValue
	if (formatX) popoutTitle = formatX(xValue)
	if (formatTitle) popoutTitle = formatTitle(xValue)

	return (
		<Layout direction="vertical" gap={0}>
			<Layout background="light-blue-background" borderBottom padding="8 12 8 12">
				<Text semiBold>{popoutTitle}</Text>
			</Layout>
			{_.map(valuesBySeries, (seriesValues, seriesIndex) => (
				<SeriesPointPopoutRow
					key={seriesIndex}
					seriesIndex={seriesIndex}
					seriesPointValue={seriesValues[seriesPointIndex]}
					xValue={xValue}
					apexObject={apexObject}
					formatSeriesLabel={formatSeriesLabel}
					formatSeriesValue={formatSeriesValue}
					isLast={seriesIndex === lastVisibleSeriesIndex}
				/>
			))}
			{extraContent}
		</Layout>
	)
}

const SeriesPointPopoutRow = ({seriesIndex, seriesPointValue, xValue, apexObject, formatSeriesLabel, formatSeriesValue, isLast}) => {
	const {colors, seriesNames, collapsedSeriesIndices} = apexObject.globals
	if (collapsedSeriesIndices.includes(seriesIndex)) return null

	const formatY = apexObject.config.yaxis[0].labels.formatter
	let seriesLabel = seriesNames[seriesIndex]
	if (formatSeriesLabel) seriesLabel = formatSeriesLabel({seriesLabel, seriesIndex, xValue})
	const iconColor = colors[seriesIndex]
	const valueFormatter = formatSeriesValue || formatY
	const value = valueFormatter ? valueFormatter(seriesPointValue) : seriesPointValue

	return (
		<Layout width="full" padding="0 0 0 12">
			<Layout width="full" height={32} borderBottom={!isLast} padding="9 12 9 0" vertical="center">
				<Layout gap={6} horizontal="last-item-end" vertical="center">
					{/* Apex tooltips use static HTML from renderToString. Icon relies on ReactSVG
						mounting before it can inject the SVG, so render a span instead. */}
					<span style={{width: 10, height: 10, borderRadius: '50%', backgroundColor: iconColor, display: 'inline-block'}} />
					<Text>{seriesLabel}:</Text>
					<Text>{value}</Text>
				</Layout>
			</Layout>
		</Layout>
	)
}
